import type { IconSvgObject } from './types';

const ArrowMoveDownRightIcon: IconSvgObject = [
  ["path", { d: "M4 3V15.9999C4 17.1044 4.89542 17.9999 5.99998 17.9999L20 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 21L20 18L17 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowMoveDownRightIcon;
